import { getAppReqParam } from './appUrlUtils';
import { getGlobalStorage } from './storage';

/**
 * 获取维度代码
 * @returns {Array} 维度代码数组
 */
export function getDimensionCode(pageCode) {
    // 获取应用请求参数
    let appReqParam = getAppReqParam();
    // 解构赋值获取应用代码和页面代码
    let { appcode, pagecode } = appReqParam;
    // 从全局存储中获取维度代码
    let dimensionMap = JSON.parse(getGlobalStorage('localStorage', 'dimenMap') || '{}');
    let dimensionCode = dimensionMap[`${appcode}-${pageCode || pagecode}`];
    if (dimensionCode) {
        return dimensionCode;
    } else {
        return [];
    }
}

